module.exports = " <div class=\"text-value-title\">{{vm.dataset.name}}</div> <div class=\"text-value-value\">{{vm.dataset.cockpitResult[0].value}}</div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/core/component/dv-text-value/dv-text-value.html
// module id = rFzF
// module chunks = 0